import React from 'react';
import { PropTypes } from 'prop-types';
import * as CustomFieldShowItems from './CustomFieldShowItem';
import * as customFieldTypes from '../../../../constants/customFields';

// Custom error handler to avoid direct use of console.error
const handleError = (message) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(message);
  }
};

// Helper function to render custom field items
const renderCustomField = (item, index, values, styles) => {
  switch (item.type) {
    case customFieldTypes.FIELD_TYPE_CHECKBOX_GROUP:
      return (
        <CustomFieldShowItems.MultiSelect
          key={`checkbox-group-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_TEXT_AREA:
      return (
        <CustomFieldShowItems.TextArea
          key={`text-area-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_TEXT:
      return (
        <CustomFieldShowItems.Line
          key={`text-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_NUMBER:
      return (
        <CustomFieldShowItems.Number
          key={`number-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_DATE:
      return (
        <CustomFieldShowItems.Date
          key={`date-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_HEADER:
      return (
        <CustomFieldShowItems.Header
          key={`header-${item.id || index}`}
          item={item}
          styles={styles}
        />
      );
    case customFieldTypes.FIELD_TYPE_SELECT:
      return (
        <CustomFieldShowItems.Select
          key={`select-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
    default:
      return (
        <CustomFieldShowItems.Line
          key={`line-${item.id || index}`}
          item={item}
          values={values}
          styles={styles}
        />
      );
  }
};

const CustomFieldShow = ({
  values, modelFormItems, styles = { thClassName: { className: ' ' } }, isHeaderVisible = false,
}) => {
  // Ensure modelFormItems is an array before mapping, handle error if not
  if (!Array.isArray(modelFormItems)) {
    handleError('Warning: modelFormItems is not an array. Please check the data structure.');
    return (
      <div style={styles?.errorMessage || { color: 'red' }}>
        <p>There was an error displaying custom fields. Please contact support.</p>
      </div>
    );
  }

  const formItems = modelFormItems.map((item, index) => renderCustomField(item, index, values, styles));

  return (
    <div style={styles?.table || {}}>
      {formItems.length > 0 && isHeaderVisible && (
        <div><strong>Custom Fields</strong></div>
      )}
      <table className="table-fixed w-full">
        <tbody>{formItems}</tbody>
      </table>
    </div>
  );
};

CustomFieldShow.propTypes = {
  values: PropTypes.object.isRequired,
  modelFormItems: PropTypes.array.isRequired,
  styles: PropTypes.object,
  isHeaderVisible: PropTypes.bool, // Updated Prop
};

export default CustomFieldShow;
